import React, { FunctionComponent, useState } from 'react';
import BasketBlock from '@/components/responsive/product/basketBlock/BasketBlock';
import MkpAvailability from '@/components/responsive/product/mkpAvailability/MkpAvailability';
import { PriceBlock } from "@/components/responsive/product/priceBlock/PriceBlock";
import { Seller } from '@/components/responsive/product/seller/Seller';
import { OfferItem } from "@/models/scope/productSheet/offer/OfferItem";
import { SOLD_BY_MKP } from "@/utils/constants";
import {Offers} from "@/models/scope/productSheet/offer/Offers";


interface Props {
    offer: OfferItem;
    soldBy: string;
    isPei: boolean;
    endDateRI: string;
    setPriceIncludeVAT: (includeVAT: boolean) => void;
    priceIncludeVAT: boolean;
    setLayerType: (layerType: string) => void;
    productId: string;
    setShowCloseLayerButton: (status: boolean) => void;
    offersData: Offers;
}

export const ChoiceBlock: FunctionComponent<Props> = ({
                                                          offer,
                                                          isPei,
                                                          setLayerType,
                                                          soldBy,
                                                          setPriceIncludeVAT,
                                                          endDateRI,
                                                          priceIncludeVAT,
                                                          productId,
                                                          setShowCloseLayerButton,
                                                          offersData
                                                      }) => {
    const {
        price,
        privateSalePrice,
        privateSalePriceWithoutTax,
        discountDetails,
        eligibilityToPrivateSale,
        seller,
        taxFreePrice,
        unitOriginPrice,
        crossedOutPriceWithoutTax,
        deaAmount,
        deeeAmount, ecoContributionsAmount, copyTaxMp,
        allowedDeliveryModes,
        offerId
    } = offer;
    const [basketBlockYPosition, setBasketBlockYPosition] = useState(0);
    let trackingData
    trackingData = {
        eventLabel: "Fiche_Produit",
        productVendorType: ("MKP"),
        productVendorName: (seller.shopName),
        productVendorId: (seller.id),
        productOfferNb: offersData ? offersData.items.length : 1,
        price: offersData && offersData.items.length > 0 ? offersData.items[offersData.winningOfferIndex]?.price : null,
    }

    return (
        <div className='choiceBlock'>
            <p>{offer.state === "new" ? "Neuf" : "Reconditionné"}</p>
            <div className='priceBlock'>
                <PriceBlock
                    eligibilityToPrivateSale={eligibilityToPrivateSale}
                    privateSalePrice={privateSalePrice}
                    endDateRI={endDateRI}
                    datePrixBarreMkp={soldBy === SOLD_BY_MKP ? offersData?.datePrixBarreMkp ?? true : true}
                    soldBy={soldBy}
                    privateSalePriceWithoutTax={privateSalePriceWithoutTax}
                    privateDiscountDetails={discountDetails}
                    priceIncludeVAT={priceIncludeVAT}
                    setPriceIncludeVAT={setPriceIncludeVAT}
                    priceInfos={offer && {
                        price: price,
                        priceWithoutTax: taxFreePrice,
                        crossedOutPrice: unitOriginPrice,
                        crossedOutPriceWithoutTax: crossedOutPriceWithoutTax,
                        discountDetails: discountDetails,
                        priceEco: deaAmount + deeeAmount + ecoContributionsAmount + copyTaxMp,
                    }}
                    showWithoutTaxOptin
                    id={`choice-bloc-price${offerId}`} />
            </div>
            {(seller && Object.keys(seller).length > 0) && <div className='sellerBlock'>
                <Seller
                    sellerType={SOLD_BY_MKP}
                    isWebOnly={isPei}
                    sellerMKP={seller}
                    isLayer
                    setLayerType={setLayerType}
                    setShowCloseLayerButton={setShowCloseLayerButton}
                />
            </div>}
            <MkpAvailability allowedDeliveryModes={allowedDeliveryModes} isLayer />
            <div className='basketBlock'>
                <BasketBlock
                    setBasketBlockYPosition={setBasketBlockYPosition}
                    basketBlockYPosition={basketBlockYPosition}
                    handleOpenLayer={setLayerType}
                    offerId={offerId}
                    productId={productId}
                    sellerName={seller.shopName}
                    trackingData={trackingData}
                />
            </div>
        </div>
    );
};